"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.frontAppTools = void 0;
const index_1 = require("./definitions/index");
const frontAppTools = index_1.toolDefListList.filter(tool => tool.name !== 'webSearch' && tool.name !== 'detectTasks' && tool.name !== 'ragSearch' && tool.name !== 'toolDetector').map(tool => ({
    name: tool.name,
    description: `tools.${tool.name}.description`
}));
exports.frontAppTools = frontAppTools;
